export default __webpack_public_path__ + "static/media/fan_spinning.0261b6ec.mp4";